import React from "react";
import "./App.css";
import Terminal from "./components/Terminal";

const getYear = () => {
  return new Date().getFullYear();
};

const welcomeMessage = `Welcome Fellow Travellers.

Type 'help' to view a list of available commands.
`;

/* const bannerCondensed =
  "             _         __     _    _                 \n" +
  " __ _ _ __ _(_)__ _   / _|___| |__| |_ __  __ _ _ _  \n" +
  "/ _| '_/ _` | / _` | |  _/ -_) / _` | '  \\/ _` | ' \\ \n" +
  "\\__|_| \\__,_|_\\__, | |_| \\___|_\\__,_|_|_|_\\__,_|_||_|\n " +
  "             |___/                                  \n" +
  "  \u00A9 " +
  getYear(); */



/*   const bannerCondensed =
"      s.                                              .s5SSSs.                                    \n" +
"      SS. .s5SSSs.  .s5SSSs.  .s5SSSs.  .s5SSSs.            SS. .s5SSSs.  s.  .s    s.  .s5SSSSs. \n" +
"      S%S       SS.       SS.       SS.       SS.     sS    `:;       SS. SS.       SS.    SSS    \n" +
"      S%S sS    S%S sS    S%S sS    `:; sS    S%S     SS        sS    S%S S%S sSs.  S%S    S%S    \n" +
"      S%S SSSs. S%S SS    S%S SSSs.     SS    S%S     `:;;;;.   SSSs. S%S S%S SS `S.S%S    S%S    \n" +
"      S%S SS    S%S SS    S%S SS        SS    S%S           ;;. SS    S%S S%S SS  `sS%S    S%S    \n" +
"     `:; SS    `:; SS    `:; SS        SS    `:;           `:; SS    `:; `:; SS    `:;    `:;    \n" +
".,;   ;,. SS    ;,. SS    ;,. SS    ;,. SS    ;,.     .,;   ;,. SS    ;,. ;,. SS    ;,.    ;,.    \n" +
"`:;;;;;:' :;    ;:' ;;;;;;;:' `:;;;;;:' ;;;;;;;:'     `:;;;;;:' :;    ;:' ;:' :;    ;:'    ;:'    \n" +  
  "  \u00A9 " +
  getYear(); */


  const bannerCondensed =
  "   _____         _          _       _          _            \n" +
  "  (_____)       | |        | |     | |        (_)      _    \n" +
  "     _  ____  _ | | ____ _ | |      \\ \\   ____ _ ____ | |_  \n" +
  "    | |/ _  |/ || |/ _  ) || |       \\ \\ / _  | |  _ \\|  _) \n" +
  " ___| ( ( | ( (_| ( (/ ( (_| |   _____) | ( | | | | | | |__ \n" +
  "(____/ \\_||_|\\____|\\____)____|  (______/ \\_||_|_|_| |_|\\___)\n" +
                                                              
    "  \u00A9 " +
    getYear();


                                                      



const prompt = ">";

function App() {
  return (
    <Terminal
      welcomeMessage={welcomeMessage}
      banner={bannerCondensed}
      terminalPrompt={prompt}
    />
  );
}

export default App;
